// Firefox doesn't support scroll-driven animations yet, so drive the
// reading progress bar (post.hbs only) from scroll position instead.
(function () {
    var progress = document.querySelector('#progress');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!progress || reduceMotion || (window.CSS && CSS.supports('animation-timeline', 'scroll()'))) {
        return;
    }

    var ticking = false;

    function update() {
        var scrollable = document.documentElement.scrollHeight - window.innerHeight;
        progress.style.transform = 'scaleX(' + (scrollable > 0 ? window.scrollY / scrollable : 0) + ')';
        ticking = false;
    }

    function requestUpdate() {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    }

    window.addEventListener('scroll', requestUpdate, {passive: true});
    window.addEventListener('resize', requestUpdate);
    update();
})();
